import React, { useState } from "react";
import { Box, Card, CardContent, TextField, Button, Typography, InputAdornment, Alert, Link } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { hubApi } from "../services/hubApi";

const fieldSx = {
  mb: 2,
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    bgcolor: "#1E293B",
    "& fieldset": { borderColor: "rgba(255,255,255,0.08)" },
    "&:hover fieldset": { borderColor: "rgba(255,107,0,0.3)" },
    "&.Mui-focused fieldset": { borderColor: "#FF6B00" },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#FF6B00" },
};

/**
 * Tela standalone /reset-password?token=... — define a nova senha a partir do link do e-mail.
 * Pública (sem login). Após sucesso, oferece voltar ao login (o app mora na raiz).
 */
export default function ResetPasswordPage() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [senha, setSenha] = useState("");
  const [confirma, setConfirma] = useState("");
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [ok, setOk] = useState(false);

  const curtaDemais = senha.length > 0 && senha.length < 12;
  const naoConfere = confirma.length > 0 && senha !== confirma;
  const podeEnviar = senha.length >= 12 && senha === confirma && !loading;

  const submeter = async (e) => {
    e.preventDefault();
    if (!podeEnviar) return;
    setLoading(true); setErro("");
    try {
      await hubApi.resetPassword(token, senha);
      setOk(true);
    } catch (err) {
      setErro(err?.response?.data?.error || "Não foi possível redefinir a senha.");
    }
    setLoading(false);
  };

  const wrap = (children) => (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0B0F19", p: 2 }}>
      <Card sx={{ maxWidth: 420, width: "100%", bgcolor: "#111827", border: "1px solid rgba(255,255,255,0.06)", borderRadius: "16px" }}>
        <CardContent sx={{ p: 4 }}>{children}</CardContent>
      </Card>
    </Box>
  );

  if (!token) {
    return wrap(
      <>
        <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>Link inválido (sem token). Solicite um novo em "Esqueci minha senha".</Alert>
        <Link href="/" underline="hover" sx={{ color: "#9CA3AF", fontSize: 14 }}>Voltar ao login</Link>
      </>
    );
  }

  if (ok) {
    return wrap(
      <Box sx={{ textAlign: "center" }}>
        <CheckCircleIcon sx={{ fontSize: 56, color: "#22C55E", mb: 1 }} />
        <Typography variant="h6" sx={{ color: "#F3F4F6", mb: 1 }}>Senha redefinida!</Typography>
        <Typography variant="body2" sx={{ color: "#9CA3AF", mb: 3 }}>Você já pode entrar com a nova senha.</Typography>
        <Button href="/" variant="contained" fullWidth size="large" sx={{ py: 1.3, bgcolor: "#FF6B00", borderRadius: "10px", "&:hover": { bgcolor: "#E06000" } }}>
          Ir para o login
        </Button>
      </Box>
    );
  }

  return wrap(
    <>
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: "#F3F4F6" }}>Nova senha</Typography>
        <Typography variant="body2" sx={{ color: "#6B7280", mt: 0.5 }}>Defina uma nova senha para seu acesso ao HUB.</Typography>
      </Box>
      {erro && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }} onClose={() => setErro("")}>{erro}</Alert>}
      <form onSubmit={submeter}>
        <TextField
          fullWidth label="Nova senha" type="password" placeholder="mínimo 12 caracteres"
          value={senha} onChange={(e) => setSenha(e.target.value)} variant="outlined" autoComplete="new-password"
          error={curtaDemais} helperText={curtaDemais ? "A senha precisa ter ao menos 12 caracteres." : " "}
          InputProps={{ startAdornment: (<InputAdornment position="start"><LockIcon sx={{ color: "#6B7280", fontSize: 20 }} /></InputAdornment>) }}
          sx={fieldSx}
        />
        <TextField
          fullWidth label="Confirmar nova senha" type="password" placeholder="repita a senha"
          value={confirma} onChange={(e) => setConfirma(e.target.value)} variant="outlined" autoComplete="new-password"
          error={naoConfere} helperText={naoConfere ? "As senhas não conferem." : " "}
          InputProps={{ startAdornment: (<InputAdornment position="start"><LockIcon sx={{ color: "#6B7280", fontSize: 20 }} /></InputAdornment>) }}
          sx={fieldSx}
        />
        <Button type="submit" fullWidth variant="contained" size="large" disabled={!podeEnviar}
          sx={{ py: 1.3, mt: 1, bgcolor: "#FF6B00", borderRadius: "10px", "&:hover": { bgcolor: "#E06000" }, "&.Mui-disabled": { bgcolor: "#333", color: "#666" } }}>
          {loading ? "Redefinindo..." : "Redefinir senha"}
        </Button>
      </form>
      <Box sx={{ textAlign: "center", mt: 2 }}>
        <Link href="/" underline="hover" sx={{ color: "#9CA3AF", fontSize: 13, "&:hover": { color: "#FF6B00" } }}>Voltar ao login</Link>
      </Box>
    </>
  );
}
